import { FC, useState, useEffect } from 'react';
import { ArtistsCard } from './card';
import { useAppSelector } from '../../../../../store/store';
import { ArtistActionsWrapper } from '../../../../Actions/ArtistActions';
import { FollowArtistButton } from '../../../../../pages/Artist/container/controls/followButton';
import { useTranslation } from 'react-i18next';
import { fetchArtistBioDetails } from '../../../../../services/artistBio';
import type { ArtistBioDetails } from '../../../../../interfaces/artist';
import { AboutArtistModal } from '../../../../AboutArtist';

export const Artist: FC = () => {
  const [t] = useTranslation(['playingBar']);
  const artist = useAppSelector((state) => state.playingNow.artist);
  const [bioDetails, setBioDetails] = useState<ArtistBioDetails | null>(null);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    if (!artist) {
      setBioDetails(null);
      return;
    }

    let isMounted = true;
    const fallbackImages = (artist.images || []).map((img) => img.url);
    fetchArtistBioDetails(artist.id, artist.name, fallbackImages).then((details) => {
      if (isMounted) {
        setBioDetails(details);
      }
    });

    return () => {
      isMounted = false;
    };
  }, [artist?.id, artist?.name]);

  if (!artist) return null;

  return (
    <>
      <ArtistActionsWrapper artist={artist} trigger={['contextMenu']}>
        <div>
          <ArtistsCard
            id={artist.id}
            title={artist?.name || 'Unknown Artist'}
            image={bioDetails?.images?.[0] || artist.images?.[0]?.url || ''}
            imageTitle={t('About the artist')}
            extra={<FollowArtistButton id={artist.id} />}
            subtitle={`${(artist.followers?.total ?? 0).toLocaleString()} ${t('followers')}`}
            verified={bioDetails ? bioDetails.verified : true}
            monthlyListeners={bioDetails?.monthlyListeners}
            bioSnippet={bioDetails?.bioSnippet}
            onClick={() => setModalOpen(true)}
          />
        </div>
      </ArtistActionsWrapper>

      <AboutArtistModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        details={bioDetails}
      />
    </>
  );
};
